
export interface Comment {
  id: string;
  moduleIndex: number;
  courseId: string;
  author: string;
  avatar: string;
  content: string;
  date: string;
  likes: number;
  isQuestion: boolean;
  replies: Reply[];
}

export interface Reply {
  id: string;
  author: string;
  avatar: string;
  content: string;
  date: string;
  likes: number;
  isInstructor: boolean;
}

export const mockComments: Comment[] = [
  {
    id: '1',
    moduleIndex: 0,
    courseId: '1',
    author: 'Maria Silva',
    avatar: 'https://public.readdy.ai/ai/img_res/995abdb7987fee1b1b424ff612dfd94e.jpg',
    content: 'Excelente introdução! O conteúdo sobre a história do audiovisual brasileiro é muito rico. Alguém sabe se existe material complementar sobre a era do cinema mudo no Brasil?',
    date: '2024-01-15',
    likes: 12,
    isQuestion: true,
    replies: [
      {
        id: 'r1',
        author: 'Prof. Carlos Mendes',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20professor%20portrait%20with%20glasses%2C%20academic%20setting%2C%20neutral%20background%2C%20confident%20expression%2C%20natural%20lighting&width=100&height=100&seq=avatar2&orientation=squarish',
        content: 'Olá Maria! Sim, recomendo o livro "Cinema Brasileiro: Das Origens à Retomada" de Fernão Ramos. É uma excelente referência complementar.',
        date: '2024-01-16',
        likes: 8,
        isInstructor: true,
      },
      {
        id: 'r2',
        author: 'João Pedro',
        avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20man%20portrait%2C%20casual%20style%2C%20neutral%20background%2C%20friendly%20smile%2C%20natural%20lighting&width=100&height=100&seq=avatar3&orientation=squarish',
        content: 'Também achei muito interessante! Obrigado pela dica do livro, professor.',
        date: '2024-01-16',
        likes: 3,
        isInstructor: false,
      },
    ],
  },
  {
    id: '2',
    moduleIndex: 0,
    courseId: '1',
    author: 'Ana Costa',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20woman%20portrait%20with%20natural%20makeup%2C%20neutral%20background%2C%20modern%20style%2C%20confident%20expression&width=100&height=100&seq=avatar4&orientation=squarish',
    content: 'Adorei a forma como o conteúdo foi organizado. Os vídeos são muito didáticos e os exemplos práticos ajudam muito na compreensão.',
    date: '2024-01-14',
    likes: 7,
    isQuestion: false,
    replies: [],
  },
  {
    id: '3',
    moduleIndex: 1,
    courseId: '1',
    author: 'Roberto Almeida',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20professional%20man%20portrait%2C%20business%20casual%2C%20neutral%20background%2C%20thoughtful%20expression%2C%20natural%20lighting&width=100&height=100&seq=avatar5&orientation=squarish',
    content: 'Tenho uma dúvida sobre a Lei do Audiovisual mencionada no módulo. Ela ainda está em vigor com as mesmas regras ou houve alterações recentes?',
    date: '2024-01-18',
    likes: 15,
    isQuestion: true,
    replies: [
      {
        id: 'r3',
        author: 'Prof. Carlos Mendes',
        avatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20professor%20portrait%20with%20glasses%2C%20academic%20setting%2C%20neutral%20background%2C%20confident%20expression%2C%20natural%20lighting&width=100&height=100&seq=avatar2&orientation=squarish',
        content: 'Ótima pergunta, Roberto! A Lei do Audiovisual passou por algumas atualizações em 2023. No material complementar do módulo 3, você encontrará um documento atualizado com todas as mudanças.',
        date: '2024-01-18',
        likes: 10,
        isInstructor: true,
      },
    ],
  },
  {
    id: '4',
    moduleIndex: 1,
    courseId: '1',
    author: 'Fernanda Lima',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20woman%20portrait%20with%20curly%20hair%2C%20warm%20smile%2C%20neutral%20background%2C%20creative%20industry%20style%2C%20natural%20lighting&width=100&height=100&seq=avatar6&orientation=squarish',
    content: 'O módulo sobre governança é fundamental para quem trabalha na área. Consegui aplicar vários conceitos no meu trabalho atual.',
    date: '2024-01-17',
    likes: 9,
    isQuestion: false,
    replies: [],
  },
];
